export const isIsoDate = (str: string) =>
  /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/.test(str) ||
  /\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z/.test(str);
